<script>
import ApiService from "@/api-services/portal.service";
import MaterialCard from "../components/materialCard.vue";
import EmployeeAccount from "../components/employeeAccount.vue";
import EmployeeMfa from "../components/employeeMfa.vue";
import EmployeeCommitment from "../components/employeeCommitments.vue";

export default {
  name: "adminDashboard",
  data: function () {
    return {
      employee: { firstname: "", employeeMatricule: "" },
      extApps: [
        {
          name: "Portail RH",
          url: "https://portailrh.chudequebec.ca",
          logo: "../../portailrh_sectools.png",
        },

        {
          name: "le SPOT (intranet du CHU)",
          url: "https://spot.chudequebec.ca",
          logo: "../../spot_sectools.png",
        },
        {
          name: "ENA",
          url: "https://fcp.rtss.qc.ca/ena-login/index.html",
          logo: "../../ena_sectools.png",
        },
        {
          name: "Espace employé",
          url: "https://paieweb.chudequebec.ca/eEspresso",
          logo: "../../logibec_sectools.png",
        },
      ],
    };
  },
  components: {
    MaterialCard,
    EmployeeAccount,
    EmployeeMfa,
    EmployeeCommitment,
  },
  methods: {
    getEmployeeInformation: async function () {
      ApiService.getEmployeeInformations()
        .then((response) => {
          this.employee = response.data.requestResult;
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status == 401) {
              this.$store.commit("setJwt", null);
              this.$store.commit("setIsAuthentified", false);
              this.$router.push("/");
            } else {
              this.$store.commit(
                "setNewErrorMessage",
                error.response.data.requestResult
              );
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$store.commit("setNewErrorMessage", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$store.commit(
              "setNewErrorMessage",
              error.response.data.requestResult
            );
          }
          console.log(error.response.data);
        });
    },
  },

  created() {
    this.getEmployeeInformation();
  },
};
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="12" lg="12" md="12" sm="12">
        <v-row>
          <v-col
            cols="4"
            xl="4"
            lg="6"
            md="12"
            sm="12"
            class="d-flex flex-column"
          >
            <MaterialCard color="primary" full-header height="100%">
              <template #heading>
                <div class="pa-2 white--text">
                  <div class="text-subtitle-1 font-weight-light">
                    Mes informations
                  </div>
                  <!-- <div class="text-caption">
                    New employees on 15th September, 2016
                  </div> -->
                </div>
              </template>
              <v-card-text>
                <v-list class="transparent" dense>
                  <v-list-item>
                    <v-list-item-subtitle class="overline"
                      >Matricule</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="text-center">
                      {{ employee.employeeMatricule }}
                    </v-list-item-subtitle>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-subtitle class="overline"
                      >Nom</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="text-center">
                      {{ employee.name }}
                    </v-list-item-subtitle>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-subtitle class="overline"
                      >Prénom</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="text-center">
                      {{ employee.firstName }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-subtitle class="overline"
                      >Date de naissance</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="text-center">
                      {{ new Date(employee.birthdate).toLocaleDateString() }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-divider inset></v-divider>

                  <v-list-item>
                    <v-list-item-subtitle class="overline"
                      >Courriel personnel</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="text-center">
                      {{ employee.personnalEmail }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-subtitle class="overline"
                      >Courriel professionnel</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="text-center">
                      {{ employee.professionalEmail }}
                    </v-list-item-subtitle>
                  </v-list-item>

                  <v-divider inset></v-divider>

                  <v-list-item>
                    <v-list-item-subtitle class="overline"
                      >Date d'embauche</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="text-center">
                      {{ new Date(employee.hiringDate).toLocaleDateString() }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-subtitle class="overline"
                      >Première journée au CHU</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="text-center">
                      {{ new Date(employee.firstDayDate).toLocaleDateString() }}
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </MaterialCard>
          </v-col>
          <v-col
            cols="4"
            xl="4"
            lg="6"
            md="12"
            sm="12"
            class="d-flex flex-column"
          >
            <MaterialCard color="primary" full-header height="100%">
              <template #heading>
                <div class="pa-2 white--text">
                  <div class="text-subtitle-1 font-weight-light">
                    Mes accès numériques
                  </div>
                  <!-- <div class="text-caption">
                    New employees on 15th September, 2016
                  </div> -->
                </div>
              </template>
              <EmployeeAccount
                class="flex d-flex flex-column"
              ></EmployeeAccount>
            </MaterialCard>
          </v-col>
          <v-col
            cols="4"
            xl="4"
            lg="6"
            md="12"
            sm="12"
            class="d-flex flex-column"
          >
            <MaterialCard color="primary" full-header height="100%">
              <template #heading>
                <div class="pa-2 white--text">
                  <div class="text-subtitle-1 font-weight-light">
                    Authentification à deux facteurs
                  </div>
                  <!-- <div class="text-caption">
                    New employees on 15th September, 2016
                  </div> -->
                </div>
              </template>
              <EmployeeMfa class="flex d-flex flex-column"></EmployeeMfa>
            </MaterialCard>
          </v-col>
          <v-col
            cols="4"
            xl="5"
            lg="12"
            md="12"
            sm="12"
            class="d-flex flex-column"
          >
            <MaterialCard color="primary" full-header height="100%">
              <template #heading>
                <div class="pa-2 white--text">
                  <div class="text-subtitle-1 font-weight-light">
                    Mes engagements
                  </div>
                  <!-- <div class="text-caption">
                    New employees on 15th September, 2016
                  </div> -->
                </div>
              </template>
              <EmployeeCommitment
                class="flex d-flex flex-column"
              ></EmployeeCommitment>
            </MaterialCard>
          </v-col>
          <v-col
            cols="8"
            xl="7"
            lg="12"
            md="12"
            sm="12"
            class="d-flex flex-column"
          >
            <MaterialCard color="primary" full-header height="100%">
              <template #heading>
                <div class="pa-2 white--text">
                  <div class="text-subtitle-1 font-weight-light">
                    Liens utiles
                  </div>
                  <!-- <div class="text-caption">
                    New employees on 15th September, 2016
                  </div> -->
                </div>
              </template>
              <v-row align="center" justify="center">
                <a
                  v-for="app in extApps"
                  :key="app.name"
                  :href="app.url"
                  class="ma-5"
                  target="_blank"
                >
                  <v-img
                    :lazy-src="app.logo"
                    max-height="175"
                    max-width="175"
                    contain
                    :src="app.logo"
                  ></v-img>
                </a>
              </v-row>

              <!-- <v-card-text class="column_wrapper">
            <div v-for="app in extApss" :key="app.name" class="text-caption">
              <v-icon>mdi-square-small</v-icon> {{ app.name }}
            </div>
          </v-card-text> -->
            </MaterialCard>
          </v-col>

          <!-- <v-col
            cols="12"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            class="d-flex flex-column"
          >
            <employee-commitment
              class=" flex d-flex flex-column"
              :employeeMatricule="this.$route.params.id"
            ></employee-commitment
          ></v-col> -->
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
img {
  padding-top: 150px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
